import { Component, OnInit } from '@angular/core';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, orderBy } from '@progress/kendo-data-query';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddCustomerDialog } from '../add-customer/add-customer.component';
import { ActivatedRoute } from '@angular/router';
import { CRMService } from '../../services/crm.service';
import { EmployeeService } from '../../services/employees.service';
import { SearchCustomer, Employee } from '../../models/models';

@Component({
    selector: 'crm-leads',
    templateUrl: './crm-leads.component.html',
    standalone: false
})
export class CrmLeads implements OnInit {
    public isLoading: boolean = false;
    public isAdd: boolean = false;
    public salesReps: Employee[] = [];
    public opsReps: Employee[] = [];
    public accountReps: Employee[] = [];
    public customers: SearchCustomer[] = [];
    public view: GridDataResult = { data: [], total: 0 };
    public state: State = {
        skip: 0,
        take: 10
    };

    private repType: string = '';
    private employeeId: number = 0;

    constructor(private crmService: CRMService, private employeeService: EmployeeService, public dialog: MatDialog, private route: ActivatedRoute) {
        
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.repType = params.repType;
            this.employeeId = params.employeeId;

            this.getCustomers();
        });

        this.getEmployees();
    }

    private getCustomers() {
        this.isLoading = true;
        this.crmService.getSearchCustomerLeads().subscribe(result => {
            this.isLoading = false;
            this.customers = result.resultCollection;
            this.setCustomerGrid();
        });

        //if (!this.repType || this.repType == '' || this.employeeId == null || this.employeeId < 1) {
        //    this.crmService.getCustomerLeads().subscribe(result => {
        //        this.customers = result;
        //        this.setCustomerGrid();
        //    });
        //} else {
        //    this.crmService.getCustomerLeadsByRepTypeEmployeeId(this.repType, this.employeeId).subscribe(result => {
        //        this.customers = result;
        //        this.setCustomerGrid();
        //    });
        //}
    }

    private getEmployees() {
        this.employeeService.getEmployeesByGroupName('Sales').subscribe(result => {
            this.salesReps = result;
        });

        this.employeeService.getEmployeesByGroupName('Ops Rep').subscribe(result => {
            this.opsReps = result;
        });

        this.employeeService.getEmployeesByGroupName('Account Managers').subscribe(result => {
            this.accountReps = result;
        });
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.state = state;
        this.setCustomerGrid();
    }

    private setCustomerGrid() {
        if (this.state.sort) {
            this.customers = orderBy(this.customers, this.state.sort);
        }

        this.view = process(this.customers, this.state);
    }

    public addNew() {
        this.isAdd = true;
    }

    public cancelEdit() {
        this.isAdd = false;
        this.getCustomers();
    }
}
